import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

type LanguageOption = {
  code: "en" | "it" | "ar";
  label: string;
};

const languageOptions: LanguageOption[] = [
  { code: "en", label: "EN" },
  { code: "it", label: "IT" },
  { code: "ar", label: "AR" },
];

const LanguageSwitcher = () => {
  const { t } = useTranslation();

  const currentLanguage = (i18n.resolvedLanguage || "en") as
    | "en"
    | "it"
    | "ar";

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="language-switcher" className="sr-only">
        {t("Language")}
      </label>
      <select
        id="language-switcher"
        value={currentLanguage}
        onChange={(event) => {
          void i18n.changeLanguage(event.target.value);
        }}
        className="bg-white/10 text-white text-xs md:text-sm rounded-md border border-white/20 px-2 py-1.5 focus:outline-none focus:border-brand-pink"
      >
        {languageOptions.map((option) => (
          <option key={option.code} value={option.code} className="text-black">
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
